export default __webpack_public_path__ + "static/media/unlimited-features.a0b8acf7.jpg";